import { Box, Button, createStyles } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import CustomPagination from "../../../../components/Pagination/CustomPagination";
import { getMar, getMarLogsNew } from "../../../../services/mar";
import UserDetail from "../MarTab/UserDetail";
import HideClient from "../ClientHide";
import ClientColumn from "../ClientColumn";
import { decrypt, formatDate, formatTime } from "../../../../utils";

import { CSVLink, CSVDownload } from "react-csv";

import moment from "moment";
import MarLogTable, {  getDescriptionFields } from "./MarLogTable/indexNew";
import { exportBrandedPdf } from "../../../../components/BrandedReport";

const useStyles = createStyles((theme) => ({
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    // overflowX: "auto",
    marginBottom: "50px",
    height: "100%",
  },
  btnContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    "& button": {
      border: "none",
      padding: "5px 30px",
      height: "50px",
      color: "black",
    },
    "& img": {
      width: "30px",
    },
  },
  mainHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  contentBody: {
    width: "100%",
    display: "flex",
    gap: "20px",
    // marginTop: "30px",
  },
  scheduleDetailRight: {
    width: "calc(100% - 270px)",
  },
  scheduleDetailRight100: {
    width: "calc(100% - 70px)",
  },
  userDetail: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // marginTop: "40px",
    "& .detail_box": {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      "& .image_box": {
        width: "80px",
        height: "80px",
        border: "1px solid rgb(230,230,230)",
        borderRadius: "10px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      },
      "& h3": {
        margin: "0",
        fontSize: "30px",
        textAlign: "center",
      },
      "& p": {
        margin: "0",
        color: "#979797",
        textAlign: "center",
      },
    },
  },
  tableParentBox: {
    height: "100%",
    backgroundColor: "#fff",
    padding: "12px 8px",
    borderRadius: 16,
    width: "100%",
    overflowX: "auto",
  },
}));

const MarLogTab = ({ refresh, userId }) => {
  const { classes } = useStyles();
  const [currentPage, setCurrentPage] = useState(1);
  // const { count, newMarLogs } = useSelector((state) => state.mar);
  const [show, setShow] = useState(true);
  const {
    selectedClient,
    filterDates,
    allData,
    logType,
    logSearch,
    newMarLogs,
    medicationLogs,
  } = useSelector((state) => state.mar);
  const { profile } = useSelector((state) => state?.profile);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    // if (refresh) getMarLog();
    getMarLog();
  }, [currentPage, refresh, selectedClient, logType]);

  const getMarLog = async () => {
    await getMarLogsNew(currentPage, null, true, logSearch); // await getMar(
    //   currentPage,
    //   null,
    //   true,
    //   filterDates,
    //   logType,
    //   undefined,
    //   true,
    // );
  };

  const formatDescriptionForCSV = (fields) => {
    if (!fields || fields.length === 0) return "-";

    return fields
      .filter(
        (field) =>
          field.value &&
          field.value !== "-" &&
          field.value !== "null" &&
          field.value !== "undefined",
      )
      .map((field) => `${field.label}: ${field.value}`)
      .join(" | ");
  };

  // Generate CSV data that matches the table exactly
  const csvData = useMemo(() => {
    if (!newMarLogs?.allData || newMarLogs?.allData?.length === 0) {
      return [];
    }

    // Define CSV headers matching the table columns
    const headers = [
      "Date",
      "Time",
      "Action",
      "Client Name",
      "Medication Name",
      "Action by",
      "Description",
    ];

    // Process the data exactly as shown in the table
    const processedData = newMarLogs?.allData
      .slice(0)
      .sort((a, b) => new Date(b?.date) - new Date(a?.date))
      .filter((v) => v?.medicationType !== "discontinued")
      .map((row) => {
        const descriptionFields = getDescriptionFields(row);
        const descriptionText = formatDescriptionForCSV(descriptionFields);

        return {
          Date: formatDate(row?.createdAt) || "-",
          Time: formatTime(row?.createdAt) || "-",
          Action: row?.logAction || "-",
          "Client Name": decrypt(row?.client?.name) || "-",
          "Medication Name": row?.form3?.medicationName || "-",
          "Action by": row?.createdBy?.name || "-",
          Description: descriptionText,
        };
      });

    return [headers, ...processedData?.map((row) => Object.values(row))];
  }, [newMarLogs]);

  return (
    <div className={classes.content}>
      {!userId ? (
        <HideClient show={show} setShow={setShow} />
      ) : (
        <Box m={20}></Box>
      )}

      <div className={classes.contentBody}>
        {show ? (
          <>{!userId && <UserDetail isClient={false} />}</>
        ) : (
          <ClientColumn />
        )}
        <div className={classes.tableParentBox}>
          <MarLogTable />
          <CustomPagination
            data={newMarLogs?.count}
            itemsPerPage={10}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      <div className={classes.btnContainer}>
        <Button
          onClick={() => {
            if (!newMarLogs?.allData?.length) return;
            const pdfRows = newMarLogs.allData
              .slice(0)
              .sort((a, b) => new Date(b?.date) - new Date(a?.date))
              .filter((v) => v?.medicationType !== "discontinued")
              .map((row) => {
                const descFields = getDescriptionFields(row);
                const desc = descFields
                  ?.filter((f) => f.value && f.value !== "-")
                  ?.map((f) => `${f.label}: ${f.value}`)
                  .join(" | ") || "-";
                return [
                  formatDate(row?.createdAt) || "-",
                  formatTime(row?.createdAt) || "-",
                  row?.logAction || "-",
                  decrypt(row?.client?.name) || "-",
                  row?.form3?.medicationName || "-",
                  row?.createdBy?.name || "-",
                  desc,
                ];
              });
            exportBrandedPdf({
              facilityName: profile?.facility?.name,
              reportTitle: "Medication Log",
              reportSubtitle: selectedClient?.name ? decrypt(selectedClient.name) : "",
              columns: ["Date", "Time", "Action", "Client", "Medication", "Action By", "Description"],
              rows: pdfRows,
              filename: `Medication_Log_${moment().format("YYYY-MM-DD")}.pdf`,
            });
          }}
          color="dark"
          variant="outline"
          title="Download PDF"
        >
          Download PDF
        </Button>
        <CSVLink
          data={csvData}
          filename={`Medication_Log_${moment().format("YYYY-MM-DD")}.csv`}
        >
          <Button
            leftIcon={
              <img src={"/assets/images/downloadFolder.png"} alt="download" />
            }
            color="yellow"
            title="Download Log"
          >
            Download CSV
          </Button>
        </CSVLink>
      </div>
    </div>
  );
};

export default MarLogTab;
